import { translateFormatter } from '@/domains/core/localization/translate';
export const t = translateFormatter<{
  votes: number;
}>([{
  "type": 6,
  "value": "votes",
  "options": {
    "=0": {
      "value": [{
        "type": 0,
        "value": "Be the first to find this useful"
      }]
    },
    "=1": {
      "value": [{
        "type": 0,
        "value": "1 person found this useful"
      }]
    },
    "other": {
      "value": [{
        "type": 7
      }, {
        "type": 0,
        "value": " people found this useful"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");